// TABLE COLUMS
// export const MembershipTableColumns = [
//   {
//     key: "Enroll_date",
//     header: "Enrolment Date",
//     sortable: true,
//     className: "min-w-[120px]"
//   },
//   {
//     key: "Membership_id",
//     header: "Membership ID",
//     sortable: true,
//     className: "min-w-[120px]"
//   },
//   // {
//   //   key: "Date_of_birth",
//   //   header: "Date of Birth",
//   //   sortable: true,
//   //   className: "min-w-[120px]"
//   // },
//   // {
//   //   key: "User_Email_id",
//   //   header: "Email Address",
//   //   sortable: true,
//   //   className: "min-w-[160px]"
//   // },
//   // {
//   //   key: "Phone_no",
//   //   header: "Phone Number",
//   //   sortable: true,
//   //   className: "min-w-[140px]"
//   // },
//   {
//     key: "Current_balance",
//     header: "Current Balance",
//     sortable: true,
//     className: "min-w-[140px] text-center",
//     render: (value) => (
//       <span className="font-medium">{Number(value).toFixed(0)}</span>
//     )
//   }
// ];

export const MembershipTableColumns = [
  {
    key: "Enroll_date",
    header: "Enrolment Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Membership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Current_balance",
    header: "Current Balance",
    sortable: true,
    className: "min-w-[140px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0)}</span>
    )
  },
  {
    key: "Total_bonus_points",
    header: "Total Bonus Points",
    sortable: true,
    className: "min-w-[140px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value ?? 0).toFixed(0)}</span>
    )
  },
  {
    key: "Total_gained_points",
    header: "Total Gained Points",
    sortable: true,
    className: "min-w-[140px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value ?? 0).toFixed(0)}</span>
    )
  },
  {
    key: "Total_redeemed",
    header: "Total Redeemed",
    sortable: true,
    className: "min-w-[140px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value ?? 0).toFixed(0)}</span>
    )
  }
];

export const MembershipTableSummaryColumns = [
  {
    key: "Enroll_date",
    header: "Enrolment Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Branch_name",
    header: "Branch Name",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Country",
    header: "Country",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Region",
    header: "Regions",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Zone",
    header: "Zone",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "City",
    header: "City",
    sortable: true,
    className: "min-w-[140px]"
  }, {
    key: "State",
    header: "State",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Tier",
    header: "Tier",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Total",
    header: "Total",
    sortable: true,
    className: "min-w-[120px] text-right",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0)}</span>
    )
  }
];


export const CampaignReportColumn = [
  {
    key: "Transaction_date",
    header: "Enrolment Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Member_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Bill_no",
    header: "Bill Number",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Branch_name",
    header: "branch",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Campaign_name",
    header: "Campaign Name",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Campaign_sub_type",
    header: "Campaign type",
    sortable: true,
    className: "min-w-[120px] text-right",
    // render: (value) => (
    //   <span className="font-medium">{ Number(value).toFixed(0)}</span>
    // )
  },
  {
    key: "total_transactions",
    header: "Transaction Amount",
    sortable: true,
    className: "min-w-[120px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0) | 0}</span>
    )
  },
  {
    key: "Earned_points",
    header: "Earned Points",
    sortable: true,
    className: "min-w-[140px] text-center",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0) | 0}</span>
    )
  },
];

export const ExpiryReportColumn = [
  {
    key: "Expiry_date",
    header: "Expiry Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Member_name",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Menbership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Expired_points",
    header: "Expired Points",
    sortable: true,
    className: "min-w-[120px]"


  },
  {
    key: "For_item",
    header: "For Item",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Points_issuance_date",
    header: "Points issuance Date",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Phone_number",
    header: "Phone Number",
    sortable: true,
    className: "min-w-[120px] text-right",

  },
  {
    key: "Email_aaddress",
    header: "Email Address",
    sortable: true,
    className: "min-w-[120px] text-right",

  }
];
export const LiabilityReportColumn = [
  {
    key: "Expiry_date",
    header: "Expiry Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Membership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Forfeited_points",
    header: "Forfeited Points",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "For_item",
    header: "For Item",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Points_issuance_date",
    header: "Points issuance Date",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Phone_number",
    header: "Phone Number",
    sortable: true,
    className: "min-w-[120px] text-right",

  },
  {
    key: "Email_aaddress",
    header: "Email Address",
    sortable: true,
    className: "min-w-[120px] text-right",

  }
];
export const RedeemptionReportColumn = [
  {
    key: "Membership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Naira_value",
    header: "Naira Value",
    sortable: true,
    className: "min-w-[120px]"
  },
  // {
  //   key: "Quantity",
  //   header: "Quantity",
  //   sortable: true,
  //   className: "min-w-[160px]"
  // },
  {
    key: "Redeem_points",
    header: "Redeem Points",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Remarks",
    header: "Remarks",
    sortable: true,
    className: "min-w-[120px] text-left item-center",

  },
  {
    key: "Transaction_date",
    header: "Transaction Date",
    sortable: true,
    className: "min-w-[120px]  text-left item-center",

  },
  {
    key: "ReferenceID",
    header: "Transaction Reference",
    sortable: true,
    className: "min-w-[120px]  text-left item-center",

  }
];
export const TransactionReportColumn = [{

  key: "Membership_id",
  header: "Membership ID",
  sortable: true,
  className: "min-w-[120px]"
  ,

},
{
  key: "Points",
  header: "Points",
  sortable: true,
  className: "min-w-[120px]"
},
{
  key: "Point_value",
  header: "Point Value",
  sortable: true,
  className: "min-w-[120px]"
},
{
  key: "TransactionRefrence",
  header: "Transaction Reference",
  sortable: true,
  className: "min-w-[120px]"
},
{
  key: "TransactionRefrence",
  header: "Refrence ID",
  sortable: true,
  className: "min-w-[120px] text-right",

},
{
  key: "Remarks",
  header: "Remarks",
  sortable: true,
  className: "min-w-[120px] text-center",

},
{
  key: "Transaction_date",
  header: "Transaction Date",
  sortable: true,
  className: "min-w-[120px]",

},
{
  key: "Timestamp",
  header: "Timestamp",
  sortable: true,
  className: "min-w-[120px] text-right",
}


];

export const CallCenterReportTable = [
  {
    key: "Child_query_log_id",
    header: "Query ticket",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Membership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Query_status",
    header: "Query Status",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Sub_query",
    header: "Sub Query type",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "callcenter_user",
    header: "Agent",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "Query_type_name",
    header: "Query type",
    sortable: true,
    className: "min-w-[120px] text-right",

  },
  {
    key: "Creation_date",
    header: "Query Registered Date",
    sortable: true,
    className: "min-w-[120px] text-right",

  },
  {
    key: "Closure_date",
    header: "Close Date",
    sortable: true,
    className: "min-w-[120px] text-right",

  }
];


export const ExpiredPointsColumn = [
  {
    key: "Membership1_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "transactionRef",
    header: "Transaction Ref",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Transaction_date",
    header: "Points Issuance Date",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Update_date",
    header: "Expiry Date",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "points_expired",
    header: "Forfeited Points",
    sortable: true,
    className: "min-w-[140px] text-right",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0)}</span>
    )
  }
];

export const UpcomingPointsColumn = [
  {
    key: "Membership1_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[140px]"
  },
  {
    key: "transactionRef",
    header: "Transaction Ref",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "Transaction_channel_code",
    header: "Channel",
    sortable: true,
    className: "min-w-[100px]"
  },
  {
    key: "Transaction_date",
    header: "Points Issuance Date",
    sortable: true,
    className: "min-w-[160px]"
  },
  {
    key: "points_to_expire",
    header: "Points to Expire",
    sortable: true,
    className: "min-w-[140px] text-right",
    render: (value) => (
      <span className="font-medium">{Number(value).toFixed(0)}</span>
    )
  },
  {
    key: "days_remaining",
    header: "Days Remaining",
    sortable: true,
    className: "min-w-[120px] text-right"
  }
];

export const OtpReportTable = [
  {
    key: "Membership_id",
    header: "Membership ID",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Response",
    header: "Otp Response Message",
    sortable: true,
    className: "min-w-[120px]"
  },
  {
    key: "Date",
    header: "Time",
    sortable: true,
    className: "min-w-[160px]"
  }
];
